var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupGlow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 517,
    height: 656,
    viewBox: "490 0 517 656",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2830_3996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M951.436 73.1922L987 20H723.691C680.604 50.8858 610.16 80.0557 545.871 188.156C494.44 274.636 509.395 522.752 523.302 636H884.413C870.734 575.372 834.622 417.397 799.605 270.518C764.588 123.639 886.235 77.7679 951.436 73.1922Z",
    fill: "url(#paint0_linear_2830_3996)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2830_3996",
    x: 490,
    y: 0,
    width: 517,
    height: 656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2830_3996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2830_3996",
    x1: 888.794,
    y1: 20,
    x2: 636.69,
    y2: 579.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupGlow);
export default __webpack_public_path__ + "static/media/popup-glow.530968e0c49728fe5a0c2f4317699edd.svg";
export { ForwardRef as ReactComponent };